var _defs, _title, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mastercard_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mastercard_svg__cls-1{fill:#32326f}.mastercard_svg__cls-2{fill:#f22f12}.mastercard_svg__cls-3{fill:#f79f1a}.mastercard_svg__cls-4{fill:#ff5f01}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "master")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mastercard_svg__cls-1",
    d: "M29,1H3A3,3,0,0,0,0,4V20a3,3,0,0,0,3,3H29a3,3,0,0,0,3-3V4A3,3,0,0,0,29,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "mastercard_svg__cls-2",
    d: "M11.7,5.4A6.6,6.6,0,1,1,5.1,12a6.59,6.59,0,0,1,6.6-6.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "mastercard_svg__cls-3",
    d: "M20.5,5.5A6.5,6.5,0,1,1,13.9,12a6.57,6.57,0,0,1,6.6-6.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "mastercard_svg__cls-4",
    d: "M13.9,12a6.23,6.23,0,0,1,2.2-4.8,6.35,6.35,0,0,1,.6,9l-.6.6A6.24,6.24,0,0,1,13.9,12"
  })));
};
export default SvgMastercard;